import React from 'react';
import LegalPage from './LegalPage';

const SECTIONS = [
  {
    heading: '1. About LockedIn',
    body: 'LockedIn is a peer-to-peer sports challenge platform. Users create and accept head-to-head challenges with other users. LockedIn is not a sportsbook and does not act as a counterparty to challenges.',
  },
  {
    heading: '2. Eligibility',
    body: 'You must meet all applicable eligibility and age requirements in your jurisdiction to create an account and fund a wallet. You are responsible for ensuring your use of LockedIn is permitted where you live.',
  },
  {
    heading: '3. Accounts',
    body: 'You are responsible for the activity on your account and for keeping your credentials secure. Provide accurate information when creating a profile.',
  },
  {
    heading: '4. Wallet, entries, and fees',
    body: 'Wallet funds are added and withdrawn through Stripe and are used for challenge entries. Accepted entries move to locked funds until settlement. A platform service fee applies to challenge earnings (5% for free members, 2% for LockedIn Plus members), calculated at settlement.',
  },
  {
    heading: '5. Settlement',
    body: 'Live game challenges settle from final scores. Custom challenges settle from the outcome agreed by the participants. Disputes are handled according to our published account safeguards.',
  },
  {
    heading: '6. Acceptable use',
    body: 'Do not use LockedIn for unlawful purposes, attempt to manipulate outcomes, or abuse other users. We may suspend accounts that violate these terms.',
  },
  {
    heading: '7. Changes',
    body: 'We may update these terms from time to time. Continued use of LockedIn after changes take effect constitutes acceptance of the updated terms.',
  },
];

export default function TermsPage() {
  return (
    <LegalPage
      title="Terms of Service"
      updated="June 2026"
      intro="These terms govern your use of LockedIn. By creating an account or using the app, you agree to them. This summary is provided for clarity and does not replace any full legal agreement we may publish."
      sections={SECTIONS}
    />
  );
}
